module.exports = __webpack_public_path__ + "static/media/degrade-background.343efade.png";